<template>
    <div class="welcome-page">
        <div id="tab-note-logo">
            <h1 id="brand-text">Tab Note</h1>
        </div>

        <div v-if="!workspaces.length" id="no-workspaces-message">
            You don't have any workspaces. 
            <br>
            <router-link class="link" to="/settings/workspaces">
                Create one now?
            </router-link>
        </div>
        <div v-else-if="!current_workspace" id="select-workspace-message">
            You don't have a workspace selected. 
            
            <div class="link">
                Select one now?
            </div>
            
        </div>
        <div v-else id="welcome-container">
            <span id="welcome-message">Welcome back.</span>



            <div id="recently-edited" class="quick-section">
                <div v-for="(note, index) in notes" :key="'recent-note-'+note.slug+index" class="recent-note">
                    <div class="note-header">
                        <router-link :to="`/${current_workspace.slug}/notes/${note.slug}`" class="link note-title">
                            {{note.title}}
                        </router-link>
                        <span class="note-updated-at">
                            {{note.updated_at || '2020-04-20 16:35'}}
                        </span>
                    </div>

                    <span v-if="note.text.length" class="note-content">
                        {{getTextFromMarkdown(note.text)}}
                    </span>
                </div>
                <div v-if="!notes.length">
                    You don't have any notes yet. <router-link to="/new"> Create one now?</router-link>
                </div>
            </div>

            <div id="quick-actions" class="quick-section">
                <div class="action">
                    <router-link class="link" to="/settings/workspaces">
                        Start a new workspace
                    </router-link>
                    <span class="action-description">
                        Workspaces allow you to keep your ideas seperated by project.
                    </span>
                </div>
                <div class="action">
                    <router-link class="link" to="/new">
                        Create a new note
                    </router-link>
                    <span class="action-description">
                        Been inspired? Lets write it down before you forget.
                    </span>
                </div>
                <div class="action">
                    <div class="link clickable" @click="$emit('AddFolderPressed')">
                        Create a new folder
                    </div>
                    <span class="action-description">
                        Been a little <em>too</em> inspired? Use folders to organise your notes.
                    </span>
                </div>
                <div v-if="current_workspace.slug !== 'documentation'" class="action">
                    <div class="link clickable" @click="$store.dispatch('selectWorkspace', 'documentation')">
                        Read the docs
                    </div>
                    <span class="action-description">
                        Get familiar with Tab Note and the Markdown syntax.
                    </span>
                </div>
            </div>
            <div id="graph" class="quick-section">
                <graph :key="current_workspace.slug"/>
                <span class="subtle">
                    Drag notes to rearrange, or double click one to view it.
                </span>
            </div>
        </div>


    </div>
</template>

<script>
import Graph from '../components/Graph.vue'
import RemoveMarkdown from 'remove-markdown';
export default {
    components: { 
        Graph
    },
    data() {
        return {

        }
    },
    methods: {
        getTextFromMarkdown(markdown) {
            return RemoveMarkdown(markdown);
        }
    },
    computed: {
        current_workspace() {
            return this.$store.getters.current_workspace;
        },

        workspaces() {
            return Object.values(this.$store.getters.workspaces);
        },
        notes() {
            return Object.values(this.$store.getters.notes).slice(0, 5);
            
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../assets/colors";
    .welcome-page
        flex: 1;
        justify-content: flex-start;
        align-items: center;
        display: flex;
        flex-direction: column;
        padding: 25px 100px 0px 100px;
        transition: padding .2s ease;

        @media only screen and (max-width: 520px) 
            padding: 25px 10px;

    #brand-text
        margin-bottom: 0px;
        margin-top: 15px;
        white-space: nowrap;

    #welcome-message
        margin-bottom: 30px;
        white-space: nowrap;

    #welcome-container
        width: 100%
        flex: 1
        // max-height: 75%
        // padding-bottom: 20vh
        display: flex
        flex-direction: column
        justify-content: space-between
        // margin-bottom: -50px;

    .quick-section
        border: 1px solid $border-medium;
        border-radius: 5px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        flex: 0.4;
        flex-grow: 2
        // width: 100%;
        margin-bottom: 50px;
        background-color: $darker-bg;
        box-shadow: $card-shadow;
        text-align: left;
        position: relative;

        &#recently-edited::before
            content: 'Recently Edited';
        &#quick-actions::before
            content: 'Quick Actions';
        &#graph::before
            content: 'Note Graph';

        &::before
            position: absolute;
            left: 5px;
            bottom: calc(100% + 5px);
            height: 10px;
            font-size: 10px;
            color: $light-text;
            opacity: 0.7;
        @media only screen and (max-width: 720px) 
            margin-bottom: 25px;


    #recently-edited
        @media only screen and (max-width: 720px) 
            order: 1;
                
    #quick-actions
          @media only screen and (max-width: 720px) 
            order: 0;
    
    .action
        margin-bottom: 10px;  

        width: calc(100% + 30px);
        margin: 0 -15px;
        padding: 5px 15px;

        &:nth-child(odd)
            background-color: darken($darker-bg, 2%);
    
    .action-description
        color: $faded-light-text;
        display: block;
        font-size: 0.7em;


    .recent-note
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;

        width: calc(100% + 30px);
        margin: 0 -15px;
        padding: 5px 15px;

        color: $faded-light-text;
        background-color: inherit;
        
        flex-grow: 1
        flex-shrink: 1

        &:nth-child(odd)
            background-color: darken($darker-bg, 2%);

    .note-header
        display: flex
        justify-content: space-between
        align-items: flex-start

    .note-updated-at
        color: $faded-light-text
        font-size: 10px;
        padding: 3px;
        padding-left: 30px;
            
        
    .note-title, .action
        color: $accent-bg;

    .note-content
        color: $faded-light-text;
        opacity: 0.5
        font-size:  0.8em
        flex-shrink: 1
        max-height: 60px
        transition: opacity 0.3s ease
        display: -webkit-box
        -webkit-line-clamp: 3
        -webkit-box-orient: vertical
        overflow: hidden

        &:hover
            opacity: 1


    #graph >*:first-child
        overflow: hidden
    #graph
        width: 100%
        // margin-top: 50px
        margin-bottom: 30vh
        min-height: 500px


    .subtle
        height: 10px;
        font-size: 10px;
        color: $light-text;
        opacity: 0.3;

            
</style>
